<button class="btn btn-link btn-slider-toggle ml-2 position-relative" [ngClass]="{ off: !value }"
  (click)="updateValue(!value)">
  <div class="d-inline-block">
    <div class="circle-indicator"></div>
  </div>
</button>
